import { CommonModule, NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TokenInterceptor } from 'authentication/interceptors/token.interceptor';
import { CustomLoadingCellRenderer } from 'shared/abstract/base-grid-loading-cell-renderer';
import { ActionButtonsRendererComponent } from 'shared/components/ag-grid/cell-renderers/action-buttons-renderer/action-buttons-renderer.component';
import { ColoredPillCellRendererComponent } from 'shared/components/ag-grid/cell-renderers/colored-pill-cell-renderer/colored-pill-cell-renderer.component';
import { InvitedUserLinkCellRendererComponent } from 'shared/components/ag-grid/cell-renderers/invited-user-link-renderer/invited-user-link-cell-renderer.component';
import { BooleanFloatingFilterComponent } from 'shared/components/ag-grid/filters/boolean-floating-filter/boolean-floating-filter.component';
import { DateRangeFloatingFilterComponent } from 'shared/components/ag-grid/filters/date-range-floating-filter/date-range-floating-filter.component';
import { DropdownFloatingFilterComponent } from 'shared/components/ag-grid/filters/dropdown-floating-filter/dropdown-floating-filter.component';
import { RangeOptionsFloatingFilterComponent } from 'shared/components/ag-grid/filters/range-options-floating-filter/range-options-floating-filter.component';
import { TooltipDirective } from 'shared/directives/tooltip.directive';
import { BooleanCellRendererComponent } from './components/ag-grid/cell-renderers/boolean-cell-renderer/boolean-cell-renderer.component';
import { DistributionTrackingChannelLogoRendererComponent } from './components/ag-grid/cell-renderers/distribution-tracking-channel-logo-renderer/distribution-tracking-channel-logo-renderer.component';
import { DistributionTrackingStatusRendererComponent } from './components/ag-grid/cell-renderers/distribution-tracking-status-renderer/distribution-tracking-status-renderer.component';
import { ListingStatusRendererComponent } from './components/ag-grid/cell-renderers/listing-status-renderer/listing-status-renderer.component';
import { NotificationStatusRendererComponent } from './components/ag-grid/cell-renderers/notification-status-renderer/notification-status-renderer.component';
import { CustomPaginationComponent } from './components/ag-grid/custom-pagination/custom-pagination.component';
import { DateFloatingFilterComponent } from './components/ag-grid/filters/date-floating-filter/date-floating-filter.component';
import { ListingStatusFloatingFilterComponent } from './components/ag-grid/filters/listing-status-floating-filter/listing-status-floating-filter.component';
import { NotificationStatusFloatingFilterComponent } from './components/ag-grid/filters/notification-status-floating-filter/notification-status-floating-filter.component';
import { ResetFiltersHeaderComponent } from './components/ag-grid/reset-filters-header/reset-filters-header.component';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { OngoingRequestsInterceptor } from './interceptors/ongoing-requests.interceptor';
import { AiFeaturesUsageRendererComponent } from './components/ag-grid/cell-renderers/ai-features-usage-renderer/ai-features-usage-renderer.component';

@NgModule({
    declarations: [
        // Components
        CustomLoadingCellRenderer,

        //Ag-grid miscellaneous
        CustomPaginationComponent,
        ResetFiltersHeaderComponent,

        //Ag-grid cell renderers
        ActionButtonsRendererComponent,
        BooleanCellRendererComponent,
        ColoredPillCellRendererComponent,
        InvitedUserLinkCellRendererComponent,
        ListingStatusRendererComponent,
        AiFeaturesUsageRendererComponent,

        //Ag-grid filters
        BooleanFloatingFilterComponent,
        DateFloatingFilterComponent,
        DateRangeFloatingFilterComponent,
        DropdownFloatingFilterComponent,
        ListingStatusFloatingFilterComponent,
        DistributionTrackingStatusRendererComponent,
        DistributionTrackingChannelLogoRendererComponent,
        NotificationStatusRendererComponent,
        NotificationStatusFloatingFilterComponent,
        RangeOptionsFloatingFilterComponent,
    ],
    exports: [
        // Modules
        ReactiveFormsModule,
        TranslateModule,
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        TranslateModule,
        NgOptimizedImage,

        // Standalone components
        TooltipDirective,
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: OngoingRequestsInterceptor, multi: true },
    ],
})
export class SharedModule {}
